import { render, staticRenderFns } from "./logotop.vue?vue&type=template&id=58a4a03c&scoped=true"
import script from "./logotop.vue?vue&type=script&lang=js"
export * from "./logotop.vue?vue&type=script&lang=js"
import style0 from "./logotop.vue?vue&type=style&index=0&id=58a4a03c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a4a03c",
  null
  
)

export default component.exports